var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{attrs:{"color":"#7B1FA2","small":"","label":"","dark":""}},[_vm._v("Type: "+_vm._s(this.question.qtype.toUpperCase()))]),_c('br'),_c('v-card',{staticStyle:{"margin-top":"20px"},attrs:{"flat":"","outlined":""}},[_c('v-card-text',[_c('div',{staticClass:"foo",domProps:{"innerHTML":_vm._s(this.question.title)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }